import React from 'react';

import { FormikDateField } from '@components/FormikFields';
import type { FormikDateFieldProps } from '@components/FormikFields/FormikDateField';

interface FormikDateRangeFieldProps {
  startField: FormikDateFieldProps;
  endField: FormikDateFieldProps;
}

export default function FormikDateRangeField({
  endField,
  startField,
}: FormikDateRangeFieldProps) {
  return (
    <>
      <FormikDateField {...startField} />
      <FormikDateField {...endField} />
    </>
  );
}
